































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '../Icon.vue'

@Component({
  components: { Icon },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    expandable: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  }
})
export default class TextareaV2 extends Vue {

}
